import { NavigateFunction } from "react-router-dom";
import * as Yup from "yup";
import { TUseTranslationTfn } from "../../data/AppType";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  encryptData,
  handleError,
  toastError,
  toastSuccess,
} from "../../utils/AppFunctions";
import { routePublic } from "../../routes/PublicRoutePath";
import { LOG_IN } from "../../services/Endpoints";
import { BIT_VALUE } from "../../utils/AppEnumerations";

export interface ILoginForm {
  username: string;
  password: string;
}

export const validationSchemaLogin = Yup.object({
  username: Yup.string().required("Username is required!"),
  password: Yup.string().required("Password is required!"),
});

export const initialValuesLogin = {
  username: "",
  password: "",
};

export const submitLogin = async (
  values: ILoginForm,
  navigation: NavigateFunction,
  t: TUseTranslationTfn
) => {
  try {
    const login = await LOG_IN(values);
    if (login && login.code === DEFAULT_STATUS_CODE_SUCCESS) {
      toastSuccess(login.message);
      navigation(
        `/${routePublic.verifyOtp}?us=${encryptData(
          `${values.username}|${BIT_VALUE.Zero}`
        )}`
      );
    } else {
      toastError(login.message);
    }
  } catch (e: any) {
    toastError(e?.resultLogin?.data.title || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(e, "submitLogin");
  }
};
